<template>
    <span>{{ value }}</span>
</template>

<script>
import moment from 'moment';
import Vue from "vue";

export default Vue.extend({
  name: 'CellRendererDecimal',
  computed: {
    value () {

      const { value } = this.params;

      if (!value) {
        return '';
      }

      return value.padStart(4, '0');
    }
  }
})
</script>
